import styled from "styled-components";

import { colors } from "shared/ui/tokens";

export const MOBILE_BREAKPOINT = 600;

export const Container = styled.div`
    min-width: 0;
`;

export const Filters = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
    margin-bottom: 16px;
`;

export const SearchField = styled.div`
    flex: 1 1 320px;
    min-width: 240px;
    max-width: 420px;

    @media (max-width: ${MOBILE_BREAKPOINT - 1}px) {
        flex-basis: 100%;
        max-width: none;
    }
`;

export const CategoryField = styled.div`
    flex: 0 1 280px;
    min-width: 220px;

    @media (max-width: ${MOBILE_BREAKPOINT - 1}px) {
        flex-basis: 100%;
    }
`;

export const Dot = styled.span<{ $tone: "danger" | "amber" }>`
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${({ $tone }) => ($tone === "danger" ? colors.danger : colors.amber)};
`;

/*
* Действие строки: на телефоне высота растёт до 44px — минимальная зона нажатия, ниже неё
* в строку не попасть пальцем. Здесь это исключение из правила «параметризуем пропом»:
* проп size один на все вьюпорты, а разной высота должна быть по медиазапросу (тот же приём,
* что у свёрнутых кнопок шапки в MenuEditor).
* */
export const RowAction = styled.div`
    @media (max-width: ${MOBILE_BREAKPOINT - 1}px) {
        button {
            height: 44px;
            padding: 0 14px;
        }
    }
`;

export const FullLabel = styled.span`
    @media (max-width: ${MOBILE_BREAKPOINT - 1}px) {
        display: none;
    }
`;

export const ShortLabel = styled.span`
    display: none;

    @media (max-width: ${MOBILE_BREAKPOINT - 1}px) {
        display: inline;
    }
`;

export const Message = styled.div`
    padding: 24px;
    color: ${colors.textSecondary};
`;
